export default __webpack_public_path__ + "static/media/request-report.85782095.svg";